import { RESET_MEDICAL_TEAM_STATE } from '../../actions/actionTypes';

import { updateParticipant } from '../cases/actions';

export function updateMedicalTeamParticipants(caseId, participantObj) {
  return updateParticipant(caseId, participantObj);
}

export function resetState() {
  return function (dispatch) {
    dispatch({ type: RESET_MEDICAL_TEAM_STATE });
  };
}
